<template>
    <div class="text-center mt-5">
        <div v-if="error">
            <p>{{ $t("Login failed. Please try again.") }}</p>
            <router-link :to="{ name: 'login' }" class="btn btn-primary">
                {{ $t("Back to Login") }}
            </router-link>
        </div>
        <div v-else>
            <p>{{ $t("Signing in...") }}</p>
        </div>
    </div>
</template>

<script>
import { LAST_LOGIN_METHOD } from "@/constant/localStorage";

const GOOGLE_OAUTH_STATE_KEY = "google_oauth_state";
const GOOGLE_OAUTH_REDIRECT_URI_KEY = "google_oauth_redirect_uri";

export default {
    data() {
        return {
            error: false,
        };
    },
    created() {
        this.handleCallback();
    },
    methods: {
        handleCallback() {
            const code = this.$route.query.code;
            const state = this.$route.query.state;

            const savedState = sessionStorage.getItem(GOOGLE_OAUTH_STATE_KEY);
            const redirectUri = sessionStorage.getItem(
                GOOGLE_OAUTH_REDIRECT_URI_KEY
            );

            sessionStorage.removeItem(GOOGLE_OAUTH_STATE_KEY);
            sessionStorage.removeItem(GOOGLE_OAUTH_REDIRECT_URI_KEY);

            if (!code || !state || state !== savedState || !redirectUri) {
                this.error = true;
                return;
            }

            this.api
                .post("/google/exchange", {
                    code,
                    redirectUri,
                })
                .then((response) => {
                    if (response?.data?.authToken) {
                        localStorage.setItem(LAST_LOGIN_METHOD, "google");

                        this.$store
                            .dispatch("user/login", response.data.authToken)
                            .then(() => {
                                this.$router.push({ name: "defaultPage" });
                            });
                    } else {
                        this.error = true;
                    }
                })
                .catch(() => {
                    this.error = true;
                });
        },
    },
};
</script>
